import { ContractModel, IContract } from "@core/models";

export const contractMocks = [
  new ContractModel({
    [IContract.id]: 1,
    [IContract.label]: "Mission",
    [IContract.description]: "Pour être libre comme l'air 🍃",
    [IContract.isSelected]: false,
  }),
  new ContractModel({
    [IContract.id]: 2,
    [IContract.label]: "CDI",
    [IContract.description]: "Pour de la stabilité et du long terme 📃",
    [IContract.isSelected]: false,
  }),
  new ContractModel({
    [IContract.id]: 3,
    [IContract.label]: "Saisonnier",
    [IContract.description]: "Pour de la flexibilité et de la mobilité 🌍",
    [IContract.isSelected]: false,
  }),
];
